module.exports = __webpack_public_path__ + "img/no-funds.111059ad.png";